import { ValidationTypes } from './types';

export const validationStrings = (
  type: ValidationTypes,
  value: string,
  emailNumbers: number
) => {
  switch (type) {
    case 'error':
      if (emailNumbers === 0) {
        return 'Ups! Raport został wysłany maksymalną liczbę razy!';
      } else return 'Nie udało się wysłać!';

    case 'success':
      return `Na adres ${value} został wysłany wynik testu. Pozostałe próby przesłania maila: ${emailNumbers}.`;

    default:
      return null;
  }
};
export const validateEmail = (
  value: string,
  emailNumbers: number,
  isSucceeded?: boolean
) => {
  const errorStrng = {
    message: validationStrings(
      isSucceeded ? ValidationTypes.success : ValidationTypes.error,
      value,
      emailNumbers
    ),
    type: isSucceeded ? ValidationTypes.success : ValidationTypes.error,
  };
  return { errorStrng };
};
